// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

export const StatusErrors = [
  { name: 'CAMERA', remark: 'Camera module', key: 1 },
  { name: 'LTE', remark: 'LTE module & network', key: 2 },
  { name: 'BLE', remark: 'BLE module', key: 4 },
  { name: 'WIFI', remark: 'Wifi module', key: 8 },
  { name: 'IMU', remark: 'IMU sensor', key: 16 },
  { name: 'MAG', remark: 'Magnetic sensor', key: 32 },
  { name: 'GPS', remark: 'GNSS module', key: 64 },
  { name: 'BATTERY', remark: 'Battery IC', key: 128 },
  { name: 'CHARGER', remark: 'Device charging IC', key: 256 },
  { name: 'EMMC', remark: 'Device storage', key: 512 },
  { name: 'CABIN', remark: 'Battery cabin', key: 1024 },
  { name: 'MB_TEMP_HIGH', remark: 'High main board temperature', key: 2048 },
  { name: 'MB_TEMP_LOW', remark: 'Low main board temperature', key: 4096 },
  { name: 'CAM_TEMP_HIGH', remark: 'High camera temperature', key: 8192 },
  { name: 'CAM_TEMP_LOW', remark: 'Low camera temperature', key: 16384 },
  { name: 'CPU_TEMP_HIGH', remark: 'High CPU temperature', key: 32768 },
  { name: 'CPU_TEMP_LOW', remark: 'Low CPU temperature', key: 65536 },
  { name: 'BATT_TEMP_HIGH', remark: 'High battery temperature', key: 131072 },
  { name: 'BATT_TEMP_LOW', remark: 'Low battery temperature', key: 262144 },
  { name: 'INTERNAL_ERROR', remark: 'Internal error', key: 524288 },
  { name: 'GS_ERROR', remark: 'G-sensor', key: 1048576 },
  { name: 'INTERNAL_ERROR', remark: '', key: 2097152 }
]
